import {BehaviorSubject, combineLatest, ReplaySubject, Subject} from 'rxjs';
import {distinctUntilChanged, filter, map, switchMap} from 'rxjs/operators';
import {mc} from '@px/helper/mc';
import {userApi} from '@px/api/user';
import {wwData$} from './worker-data';
import {userInfo$} from './user';
import {accountGray$} from './account-gray';

export const utaState$ = new BehaviorSubject<UtaState>(createInitUatState());
export const isUtaSpot$ = new BehaviorSubject<boolean>(false);
export const isUtaSpotUpgrading$ = new BehaviorSubject<boolean>(false);
export const utaAccountMode$ = new BehaviorSubject<UtaAccountMode>('Multi');

const loadUtaInfo$ = new Subject<void>();
export const unifiedAccountUpgradeInfo$ = new BehaviorSubject<UnifiedAccountUpgradeInfo>(createUnifiedAccountUpgradeInfo());
export const isSupportUtaSpot$ = new ReplaySubject<boolean>(1);

export function checkIsUtaSpot(spotState: 0 | 1 | 2) {
  return spotState === 2;
}

export function checkIsUtaUpgrading(spotState: 0 | 1 | 2) {
  return spotState === 1;
}

utaState$.pipe(map((o) => o.spot)).subscribe((spotState) => {
  isUtaSpotUpgrading$.next(spotState === 1);
  isUtaSpot$.next(spotState === 2);
});

wwData$
  .pipe(
    filter((o) => o.type === 'uta-state'),
    map((o) => o.data as UtaState)
  )
  .subscribe(utaState$);

userInfo$
  .pipe(
    map((o) => o.uta),
    filter(Boolean)
  )
  .subscribe(utaState$);

accountGray$
  .pipe(
    filter((accountGray) => !!accountGray),
    map((accountGray) => {
      return accountGray ? !!accountGray.spotUta : false;
    })
  )
  .subscribe((state) => {
    isSupportUtaSpot$.next(state);
  });

combineLatest({isSupportUtaSpot: isSupportUtaSpot$, utaState: utaState$})
  .pipe(
    map(({isSupportUtaSpot, utaState}) => isSupportUtaSpot && (utaState.spot === 0 || utaState.spot === 1)),
    distinctUntilChanged(),
    filter(Boolean)
  )
  .subscribe(() => {
    loadUtaInfo$.next();
  });

loadUtaInfo$.pipe(switchMap(loadUtaInfo)).subscribe((o) => unifiedAccountUpgradeInfo$.next(o));

async function loadUtaInfo() {
  const {data, error} = await userApi.getUtaInfo();
  if (error) {
    mc.send('toast', 'error', error);
  }
  return data || createUnifiedAccountUpgradeInfo();
}

async function loadGray(): Promise<boolean> {
  const data = await loadUserGray();

  return data ? !!data.spotUta : false;
}

async function loadUserGray(): Promise<any> {
  const {data, error} = await userApi.getUserBizGray();
  if (error) {
    mc.send('toast', 'error', error);
  }
  return data;
}

function createUnifiedAccountUpgradeInfo(): UnifiedAccountUpgradeInfo {
  return {
    userId: 0,
    spotUnifiedAccountUpgradeStatus: 0,
    spotUnifiedAccountUpgradeStep: 0,
    withdrawAndDepositCheckPassed: false,
    withdrawAndDepositCheckDetail: null,
    spotOrderCheckPassed: false,
    spotOrderCheckDetail: null,
    marginBorrowCheckPassed: false,
    marginBorrowCheckDetail: null,
  };
}

function createInitUatState(): UtaState {
  return {
    spot: 0,
  };
}
